@if (userHasAccess) {
  <div>
    @if (isRenewal) {
      <a [href]="planAdvisorRenewalSSOUrl" class="external-link">
        {{ planAdvisorLabel || "Plan Advisor v2 - Renewal"}}
        <span class="material-symbols-outlined">open_in_new</span>
      </a>
    }
    @if (!isRenewal) {
      <a [href]="planAdvisorNewToBlueSSOUrl" class="external-link">
        {{ planAdvisorLabel || "Plan Advisor v2 - New to Blue"}}
        <span class="material-symbols-outlined">open_in_new</span>
      </a>
    }
  </div>
} @else {
  @if (agencyModernizationPilot) {
    <div class="loading-container warning-message">
      {{ noEntitlementsMessage || 'Your currently selected agency does not have access to log in to Plan Advisor. Try
      a different agency if available.'}}
    </div>
  }
}
